import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent {
  sidebarHidden = window.innerWidth <= 768;

  toggleSidebar(): void {
    this.sidebarHidden = !this.sidebarHidden;
  }
}
